import { formatDate } from "@ui-seeker/utils"

export const dateToString = date => {
	return Array.isArray(date)
		? date.map(d => formatDate(d, { format: 'yyyy-MM-dd' }))
		: formatDate(date, { format: 'yyyy-MM-dd' })
}